<template>
  <div class="award-log-container">
    <template v-if="list.length">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" @load="loadMore" finished-text="没有更多了">
        <div class="log-item" v-for="item in list" :key="item.id" @click="toDetail(item)">
          <div class="log-text">
            <p>{{item.award_name}}</p>
          </div>
          <img src="../../../assets/icon/icons8-right_4@2x.png">
          <div v-if="item.status === 0" class="award-label">待领奖</div>
          <div v-else-if="item.status === 1" class="award-label await">已领奖</div>
          <div v-else-if="item.status === 2" class="award-label expire">已过期</div>
          <div v-else class="award-label await">已完成</div>
          <div class="valid-time" v-if="item.valid_end_time">有效期：{{ item.valid_end_time }}</div>
        </div>
      </van-list>

    </template>
    <template v-else>
      <p class="blank">暂无纪录</p>
    </template>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { List, Pagination } from 'vant'
Vue.use(List).use(Pagination)

export default {
  name: 'AwardLog',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
      totalPage: 1
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    getList() {
      console.log('getLIst')
      var that = this
      var params = { page: this.page + 1 }
      this.axios.get('/activity/award/log/', { params: params }).then(function(res) {
        console.log(res)
        that.loading = false
        that.list = that.list.concat(res.data.records)
        that.page = res.data.current
        that.totalPage = res.data.pages
      }).catch(function(error) {
        that.loading = false
        console.log(error)
      })
    },

    loadMore() {
      if (this.totalPage === this.page) {
        this.finished = true
        this.loading = false
      } else {
        this.getList()
      }
    },

    /**
     * 查看中奖订单详情
     */
    toDetail(item) {
      this.$router.push({ path: '/user/award/detail', query: { logId: item.id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.award-log-container{
  .log-item{
    height: 40px;
    padding: 20px 20px 20px 30px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3px;
    position: relative;
    .log-text{
      p{
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
      span{
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    img{
      width: 6px;
      height: 10px;
    }
    .award-label{
      position: absolute;
      top: 0;
      right: 0;
      width: 60px;
      height: 20px;
      border-radius: 0 0 0 13px;
      background-color: #b8e986;
      // opacity: 0.3;
      color: #417505;
      font-size: 10px;
      font-weight: 600;
      line-height: 20px;
      text-align: center;
    }
    .await{
      color: #ffffff;
      background-color: #ff6d63;
      opacity: 0.8;
    }
    .expire{
      color: #ffffff;
      background-color: #747474;
      opacity: 0.8;
    }
    .valid-time {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #ff6d63;
      font-size: 10px;
      font-weight: bold;
    }
  }
  .blank{
    text-align: center;
    color: #4a4a4a;
    font-size: 14px;
    font-weight: 400;
    margin: 245px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/award/log.vue